module.exports = __webpack_public_path__ + "img/east-side-radio.f082488c.png";